export const makeLensPricingMatrixColumns = (lensTypeLabels = {}) => [
    {
        Header: "Model",
        accessor: "lensModel.modelName",
        enableFilter: true,
        filterPlaceholder: "Filter by model",
        width: 180,
    },
    {
        Header: "Manufacturer",
        accessor: "lensModel.manufacturer.name",
        enableFilter: true,
        filterPlaceholder: "Filter by manufacturer",
        width: 150,
    },
    {
        Header: "Brand",
        accessor: "lensModel.manufacturerBrand.brandName",
        width: 120,
    },
    {
        Header: "Lens Type",
        accessor: "lensModel.lensType",
        Cell: ({ value }) => (value ? lensTypeLabels[value] || value : '—'),
        enableFilter: true,
        filterPlaceholder: "Filter by type",
        width: 130,
    },
    {
        Header: "Material",
        accessor: "lensMaterial.name",
        enableFilter: true,
        filterPlaceholder: "Filter by material",
        width: 130,
    },
    {
        Header: "Index",
        accessor: "lensIndex.indexValue",
        width: 80,
        enableFilter: true,
        filterPlaceholder: "Filter by index",
    },
    // {
    //     Header: "Sphere Range",
    //     accessor: (row) => {
    //         if (row.sphereMin !== null || row.sphereMax !== null) {
    //             return `${row.sphereMin || '−∞'} to ${row.sphereMax || '+∞'}`;
    //         }
    //         return 'All';
    //     },
    //     width: 130,
    // },
    // {
    //     Header: "Cylinder Range",
    //     accessor: (row) => {
    //         if (row.cylinderMin !== null || row.cylinderMax !== null) {
    //             return `${row.cylinderMin || '−∞'} to ${row.cylinderMax || '+∞'}`;
    //         }
    //         return 'All';
    //     },
    //     width: 140,
    // },
    // {
    //     Header: "Base Cost",
    //     accessor: "baseCost",
    //     Cell: ({ value }) => `$${parseFloat(value).toFixed(2)}`,
    //     width: 100,
    // },
    {
        Header: "Retail",
        accessor: "baseRetailPrice",
        Cell: ({ value }) => `$${parseFloat(value).toFixed(2)}`,
        width: 110,
        enableFilter: true,
        filterPlaceholder: "Filter by price",
        type: 'number'
    },
    {
        Header: "Margin %",
        accessor: "targetMarginPct",
        Cell: ({ value }) => (value !== null && value !== undefined && value !== '' ? `${parseFloat(value).toFixed(2)}%` : '—'),
        width: 95,
    },
    {
        Header: "Treatments",
        accessor: (row) => row.pricingTreatments?.length || 0,
        Cell: ({ value }) => value > 0 ? `${value} treatment${value !== 1 ? 's' : ''}` : '−',
        width: 100,
    },
];
